export default __webpack_public_path__ + "static/media/PQu.f6898750.jpg";